import ActiveEnroll from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/active-enroll';
import Container from '@/components/container';
import data from '../../../constants/data';

export default function Join() {
  return (
    <Container style={{ overflowX: 'auto' }} bg margin={false}>
      <ActiveEnroll data={data} destory />
    </Container>
  );
}
